var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompartir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Compartir",
    transform: "translate(6682.729 3151.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98293",
    "data-name": "Trazado 98293",
    d: "M152.684,253.342a3.008,3.008,0,0,0,0-2.684m0,2.684a3,3,0,1,1,0-2.684m0,2.684,6.632,3.316m-6.632-6,6.632-3.316m0,0A3,3,0,1,0,159,246,3,3,0,0,0,159.316,247.342Zm0,9.316A3,3,0,1,0,162,255,2.994,2.994,0,0,0,159.316,256.658Z",
    transform: "translate(-6828.729 -3393.5)",
    fill: "none",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompartir);
export default __webpack_public_path__ + "static/media/compartir.34a360c24463be3b9d2e13cbf1ed068b.svg";
export { ForwardRef as ReactComponent };